export default "__VITE_ASSET__DD$UYplM__"